import { Point } from '../../_common/client/point';

interface Gestures {
    translation: Point;
    zoom: number;
    zoomCenter: Point;
}

function getTouch(touches: Touch[], id: number): Touch | null {
    return touches.find(t => t.identifier === id) ?? null;
}

function hasTouch(touches: Touch[], id: number): boolean {
    return getTouch(touches, id) != null;
}

function averagePosition(touches: Touch[]): Point {
    const pos = touches.reduce<Point>((acc, t) => acc.add(t.clientX, t.clientY), Point.ORIGIN);
    return pos.scale(1 / touches.length);
}

function averageDistance(touches: Touch[], x: number, y: number): number {
    const acc = touches.reduce<number>((acc, t) => acc + Point.from(t.clientX, t.clientY).distance(x, y), 0);
    return acc / touches.length;
}

function recognizeGestures(viewport: HTMLElement, touchList: TouchList, prevTouchList: TouchList): Gestures {
    let touches = Array.from(touchList);
    let prevTouches = Array.from(prevTouchList);

    touches = touches.filter(t => hasTouch(prevTouches, t.identifier));
    prevTouches = prevTouches.filter(t => hasTouch(touches, t.identifier));
    if (touches.length !== prevTouches.length) {
        console.warn("Something weird's going on in the gesture recognition!");
    }

    if (touches.length === 0) {
        return { translation: Point.ORIGIN, zoom: 1, zoomCenter: Point.ORIGIN };
    }
    if (touches.length == 1) {
        return {
            translation: Point.from(touches[0].clientX, touches[0].clientY).subtract(
                Point.from(prevTouches[0].clientX, prevTouches[0].clientY)
            ),
            zoom: 1,
            zoomCenter: Point.ORIGIN,
        };
    }

    const avgPos = averagePosition(touches);
    const prevAvgPos = averagePosition(prevTouches);
    const avgDistance = averageDistance(touches, ...avgPos.tuple);
    const prevAvgDistance = averageDistance(prevTouches, ...prevAvgPos.tuple);

    return {
        translation: avgPos.subtract(prevAvgPos),
        zoom: touches.length >= 2 && prevTouches.length >= 2 ? avgDistance / prevAvgDistance : 1,
        zoomCenter: avgPos.subtract(viewport.offsetLeft, viewport.offsetTop),
    };
}

export { recognizeGestures };
